import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal } from 'ducks/ui/actions';
import AddInvoiceAddressInfo from './AddInvoiceAddressInfo';
import EditInvoiceAddressInfo from './EditInvoiceAddressInfo';
import AddEmployeeInfo from './AddEmployeeInfo';
import PasswordResetConfirmInfo from './PasswordResetConfirmInfo';
import CreateOrderInfo from './CreateOrderInfo';
import ConfirmDialog from './ConfirmDialog';
import InfoModal from './InfoModal';

class ModalsRoot extends React.PureComponent {
  render() {
    const { handleCloseModal } = this.props;
    return (
      <React.Fragment>
        <AddInvoiceAddressInfo close={handleCloseModal} />
        <EditInvoiceAddressInfo close={handleCloseModal} />
        <AddEmployeeInfo close={handleCloseModal} />
        <PasswordResetConfirmInfo close={handleCloseModal} />
        <CreateOrderInfo close={handleCloseModal} />
        <ConfirmDialog close={handleCloseModal} />
        <InfoModal close={handleCloseModal} />
      </React.Fragment>
    );
  }
}

ModalsRoot.propTypes = {
  handleCloseModal: PropTypes.func.isRequired
}

const mapDispatch = {
  handleCloseModal: closeModal
};

export default connect(null, mapDispatch)(ModalsRoot);


// WEBPACK FOOTER //
// ./src/components/globalModals/ModalRoot.jsx